import { render, staticRenderFns } from "./VRadioButton.vue?vue&type=template&id=01593d36"
import script from "./VRadioButton.vue?vue&type=script&lang=js"
export * from "./VRadioButton.vue?vue&type=script&lang=js"
import style0 from "./VRadioButton.vue?vue&type=style&index=0&id=01593d36&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01593d36')) {
      api.createRecord('01593d36', component.options)
    } else {
      api.reload('01593d36', component.options)
    }
    module.hot.accept("./VRadioButton.vue?vue&type=template&id=01593d36", function () {
      api.rerender('01593d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VRadioButton.vue"
export default component.exports